export default __webpack_public_path__ + "static/media/STAR_TINY_GREY.f141f16b.svg";